"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
import SliderContent from "../widgets/slider";

export default function SliderComponent() {
  const list = [
    {
      description:
        "Our global sales skyrocketed thanks to seamless multi-currency payments.",
      imgUrl: "/images/avatar.png",
      name: "John Idamiebi",
      rating: 4,
      title: "CEO Tim Agros",
    },
    {
      description:
        "Our business expanded globally without worrying about compliance and payment processing. This platform made it easy!",
      imgUrl: "/images/avatar-1.png",
      name: "Esther Ike",
      rating: 4,
      title: "CEO Tim Agros",
    },
    {
      description:
        "The payouts are fast, and the support team is amazing. Highly recommended!",
      imgUrl: "/images/avatar-2.png",
      name: "Hannah Oyedepo",
      rating: 4,
      title: "CEO Tim Agros",
    },
    {
      description:
        "Our global sales skyrocketed thanks to seamless multi-currency payments.",
      imgUrl: "/images/avatar-3.png",
      name: "Sammy Okanlawon",
      rating: 4,
      title: "CEO Tim Agros",
    },
  ];
  return (
    <Swiper
      modules={[Autoplay]}
      autoplay={{ delay: 3000 }}
      loop={false}
      spaceBetween={20}
      slidesPerView="auto"
      className="w-full"
      style={{ maxWidth: "100%" }}
    >
      {list.map((_, index) => (
        <SwiperSlide key={index} className="max-w-[400px] flex-shrink-0 h-full">
          <SliderContent
            title={_.title}
            rating={_.rating}
            description={_.description}
            imgUrl={_.imgUrl}
            name={_.name}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
